export const messages = {
  items: {
    id: 'admin/promotions.form.utils.items',
  },
  maxItemsPerCart: {
    label: {
      id: 'admin/promotions.form.restrictions.max-items-per-cart',
    },
    ariaLabel: {
      id: 'admin/promotions.form.restrictions.max-items-per-cart.input.aria-label',
    },
  },
  applyTo: {
    label: {
      id: 'admin/promotions.form.restrictions.max-items-per-cart.apply-to',
    },
    cheapest: {
      id: 'admin/promotions.form.restrictions.max-items-per-cart.apply-to.cheapest',
    },
    mostExpensive: {
      id: 'admin/promotions.form.restrictions.max-items-per-cart.apply-to.most-expensive',
    },
  },
  maxItemsPerAttribute: {
    label: {
      id: 'admin/promotions.form.restrictions.max-items-per-attribute',
    },
    ariaLabel: {
      id: 'admin/promotions.form.restrictions.max-items-per-attribute.aria-label',
    },
    attribute: {
      id: 'admin/promotions.form.restrictions.max-items-per-attribute.attribute',
    },
  },
}
